import { useEffect, useState } from 'react';
import classes from 'components/StoreInfo/StoreInfo.module.scss';
import Constants from 'config/constants';
import { Format } from 'utils/Format';
import { CheckCircle, Cancel, ExpandLess, ExpandMore, Phone, Room } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import DSGImage from 'assets/svg/dsg.svg';
import GGImage from 'assets/svg/gg.svg';
import { StoreChain } from 'utils/StoreChain';

export default function StoreInfo(props) {
	const [showAltChain, setShowAltChain] = useState(null);
	const [closedDay, setClosedDay] = useState(null);

	const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

	useEffect(() => {
		setShowAltChain(StoreChain.isMultiChain(props.stores, props.pickupWebsite));
		// eslint-disable-next-line
	}, [props.stores]);

	const PickupLocation = (props) => {
		return (
			<div className={classes.StoreTile}>
				<div className={classes.StoreTileContent}>
					{!props.inDialog &&
					<div className={classes.SuggestedText}>
						<p className="body-tiny upper bold"
							 style={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? {color: "#001F39"} : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? {color: "#388DAE"} : {color: "#006554"})}>
							{(props.checkedIn || props.pickedUp) ?
								<>
									{props.checkedIn &&
									<>
										Checked In
									</>
									}
									{props.pickedUp &&
									<>
										Complete
									</>
									}
								</>
								:
								<>
									{!(props.openStatus === Constants.STORE_STATUS_CLOSED) && !props.expired &&
									<>
										Ready For Pickup
									</>
									}
								</>
							}
						</p>
					</div>
					}
					<PickupLocationTile
						store={props.store}
						showAltChain={props.showAltChain}
						pickupWebsite={props.pickupWebsite}
						openStatus={props.openStatus}
						setStoreOpen={props.setStoreOpen}
						setCurbsideStoreOpen={props.setCurbsideStoreOpen}
						setHoursOpen={props.setHoursOpen}
						extend={props.extend} />
				</div>
			</div>
		)
	};

	const PickupLocationTile = (props) => {
		const [storeInfoOpen, setStoreInfoOpen] = useState(!!props.extend);

		const storeHours = props.store.hours;
		const curbsideHours = props.store.curbsideHours;

		const handleStoreInfo = () => {
			setStoreInfoOpen(!storeInfoOpen);
		};

		const StoreHourItem = (props) => {
			if (Format.splitStoreHours(props.hours) === 'Closed') {
				setClosedDay(props.day);
			}

			return (
				<div className={classes.StoreHourParent}>
					<div className={classes.StoreHourChild}>
						<p className="body-medium">{props.day}</p>
					</div>
					<div className={classes.StoreHourChild}>
						<p className="body-medium">{props.day === closedDay ? 'Closed' : Format.splitStoreHours(props.hours)}</p>
					</div>
				</div>
			);
		};

		const ClosedMessage = (props) => {
			return (
				<div className={classes.StoreStatus}>
					<Cancel className={classes.StoreIcon} style={{ fill: "#B80818" }} fontSize="small"/>
					<p className="body-small" style={{color: "#B80818"}}>{`Temporarily closed for ${props.type} pickup`}</p>
				</div>
			)
		};

		const StoreMessage = (props) => {
			const openHour = Format.getOpenHour(storeHours[daysOfWeek[new Date().getDay()]]);
			const openMinute = Format.getOpenMinute(storeHours[daysOfWeek[new Date().getDay()]]);
			const closedHour = Format.getClosedHour(storeHours[daysOfWeek[new Date().getDay()]]);
			const closedMinute = Format.getClosedMinute(storeHours[daysOfWeek[new Date().getDay()]])
			const storeOpen = Format.isBetweenOpeningHours(openHour, openMinute, closedHour, closedMinute);

			const curbsideOpenHour = Format.getOpenHour(curbsideHours[daysOfWeek[new Date().getDay()]]);
			const curbsideOpenMinute = Format.getOpenMinute(curbsideHours[daysOfWeek[new Date().getDay()]]);
			const curbsideClosedHour = Format.getClosedHour(curbsideHours[daysOfWeek[new Date().getDay()]]);
			const curbsideClosedMinute = Format.getClosedMinute(curbsideHours[daysOfWeek[new Date().getDay()]])
			const curbsideStoreOpen = Format.isBetweenOpeningHours(curbsideOpenHour, curbsideOpenMinute, curbsideClosedHour, curbsideClosedMinute);

			let open = true;
			if (isNaN(openHour) || isNaN(curbsideOpenHour)|| isNaN(closedHour) || isNaN(curbsideClosedHour)) {
				open = false;
			}
			(storeOpen || curbsideStoreOpen) && props.setHoursOpen && props.setHoursOpen(true);

			// Pass open status back to check in dialog
			if (props.setStoreOpen || props.setCurbsideStoreOpen) {
				storeOpen && props.setStoreOpen(true);
				curbsideStoreOpen && props.setCurbsideStoreOpen(true);
			}

			return (
				<div>
					{props.openStatus === Constants.STORE_STATUS_CLOSED || !open ?
						<ClosedMessage type={'order'} />
						:
						<>
							{props.openStatus === Constants.STORE_STATUS_OPEN &&
							<>
								{storeOpen || curbsideStoreOpen ?
									<>
										{storeOpen && curbsideStoreOpen ?
										<>
											<div className={classes.StoreStatus}>
												<CheckCircle className={classes.StoreIcon} style={{fill: "#006554"}} fontSize="small"/>
												<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_DEFAULT_MSG} ${Format.getClosedTime(storeHours[daysOfWeek[new Date().getDay()]])}`}</p>
											</div>
										</>
										:
										<>
											{storeOpen &&
											<>
												<div data-test-id="store-info-disclaimer-instore" className={classes.StoreStatus}>
													<CheckCircle className={classes.StoreIcon} style={{ fill: "#006554" }} fontSize="small"/>
													<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_IN_STORE_MSG_1} ${Format.getClosedTime(storeHours[daysOfWeek[new Date().getDay()]])}`}</p>
												</div>
											</>
											}
											{curbsideStoreOpen &&
											<>
												<div data-test-id="store-info-disclaimer-curbside" className={classes.StoreStatus}>
													<CheckCircle className={classes.StoreIcon} style={{ fill: "#006554" }} fontSize="small"/>
													<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_CURBSIDE_MSG_1} ${Format.getClosedTime(curbsideHours[daysOfWeek[new Date().getDay()]])}`}</p>
												</div>
											</>
											}
										</>
										}
									</>
									:
									<>
										{(curbsideStoreOpen || storeOpen) ?
											<>
												<div className={classes.StoreStatus}>
													<CheckCircle className={classes.StoreIcon} style={{fill: "#006554"}} fontSize="small"/>
													<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_DEFAULT_MSG} ${Format.getClosedTime(storeHours[daysOfWeek[new Date().getDay()]])}`}</p>
												</div>
											</>
											:
											<>
												<div className={classes.StoreStatus}>
													<Cancel className={classes.StoreIcon} style={{ fill: "#B80818" }} fontSize="small"/>
													<p className="body-small" style={{color: "#B80818"}}>{`${Constants.STORE_OPEN_CURBSIDE_MSG_2} ${Format.getOpenTime(curbsideHours[daysOfWeek[new Date().getDay()]])}`}</p>
												</div>
											</>
										}
									</>
								}
							</>
							}
							{props.openStatus === Constants.STORE_STATUS_CURBSIDE &&
							<>
								{curbsideStoreOpen ?
									<>
										<div className={classes.StoreStatus}>
											<CheckCircle className={classes.StoreIcon} style={{ fill: "#006554" }} fontSize="small"/>
											<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_CURBSIDE_MSG_1} ${Format.getClosedTime(curbsideHours[daysOfWeek[new Date().getDay()]])}`}</p>
										</div>
									</>
									:
									<>
										<div className={classes.StoreStatus}>
											<Cancel className={classes.StoreIcon} style={{ fill: "#B80818" }} fontSize="small"/>
											<p className="body-small" style={{color: "#B80818"}}>{`${Constants.STORE_OPEN_CURBSIDE_MSG_2} ${Format.getOpenTime(curbsideHours[daysOfWeek[new Date().getDay()]])}`}</p>
										</div>
									</>
								}
							</>
							}
							{props.openStatus === Constants.STORE_STATUS_IN_STORE &&
							<>
								{storeOpen ?
									<>
										<div data-test-id="store-info-disclaimer-instore" className={classes.StoreStatus}>
											<CheckCircle className={classes.StoreIcon} style={{ fill: "#006554" }} fontSize="small"/>
											<p className="body-small" style={{color: "#006554"}}>{`${Constants.STORE_OPEN_IN_STORE_MSG_1} ${Format.getClosedTime(storeHours[daysOfWeek[new Date().getDay()]])}`}</p>
										</div>
									</>
									:
									<>
										<div className={classes.StoreStatus}>
											<Cancel className={classes.StoreIcon} style={{ fill: "#B80818" }} fontSize="small"/>
											<p className="body-small" style={{color: "#B80818"}}>{`${Constants.STORE_OPEN_IN_STORE_MSG_2} ${Format.getOpenTime(storeHours[daysOfWeek[new Date().getDay()]])}`}</p>
										</div>
									</>
								}
							</>
							}
						</>
					}
				</div>
			)
		};

		return (
			<div className={classes.PickupLocationTile}>
				{props.store &&
				<>
					<div>
						{props.showAltChain &&
						<>
							{props.store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS &&
							<div className={classes.ChainContainer}>
								<img src={DSGImage} alt="DICKS SPORTING GOODS"/>
							</div>
							}
							{props.store.chain === Constants.CHAIN_GOLF_GALAXY &&
							<div className={classes.ChainContainer}>
								<img src={GGImage} alt="GOLF GALAXY"/>
							</div>
							}
						</>
						}
						<div className={classes.StoreNameText}>
							<p className="body-large-alt upper bold" style={props.store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS ? {color: "#006554"} : (props.store.chain === Constants.CHAIN_PUBLIC_LANDS ? {color: "#388DAE"} : {color: "#001F39"})}>{props.store.name}</p>
						</div>
						<div className={classes.StoreLocationText}>
							<p className="body-medium" style={{color: "#4F4F4F"}}>{Format.capitalizeWords(props.store.street1)}</p>
						</div>
						{props.openStatus &&
						<div className={classes.StoreMessage}>
							<StoreMessage openStatus={props.openStatus}
														setStoreOpen={props.setStoreOpen}
														setCurbsideStoreOpen={props.setCurbsideStoreOpen}
														setHoursOpen={props.setHoursOpen} />
						</div>
						}
					</div>
					<div className={classes.StoreLinks}>
						<div>
							<Link className={classes.StoreLinkMap}
										underline="always"
										target="_blank"
										href={`https://www.google.com/maps?saddr=My+Location&daddr=${props.store.chain},${props.store.street2},${props.store.street1},${props.store.zip}`}>
								<Room className={classes.StoreLinkIcon} fontSize="default"/>
								<p className="body-small bold underline">Get Directions</p>
							</Link>
						</div>
						<div>
							<Link className={classes.StoreLinkPhone}
										underline="always"
										href={`tel:${props.store.phone},0,0`}>
								<Phone className={classes.StoreLinkIcon} fontSize="default"/>
								<p className="body-small bold underline">{props.store.phone}</p>
							</Link>
						</div>
					</div>
					<div>
						<p className={storeInfoOpen ? `dropdown underline ${props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? `dropdown-selected-gg` : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? `dropdown-selected-pl` : `dropdown-selected-dsg`)}` : `dropdown underline`} style={{color: "#4F4F4F"}}>
							<div className={classes.StoreInfoDropdown} onClick={handleStoreInfo}>
								Store Info
								{storeInfoOpen ?
									<ExpandLess fontSize="large"/>
									:
									<ExpandMore fontSize="large"/>
								}
							</div>
						</p>
						<Collapse in={storeInfoOpen} timeout="auto" unmountOnExit>
							<div className={classes.StoreAddress}>
								<p className="body-medium">{Format.capitalizeWords(props.store.street1)}</p>
								<p className="body-medium">{Format.capitalizeWords(props.store.street2)}</p>
								<p className="body-medium">{Format.capitalizeWords(props.store.city)}, {props.store.state} {props.store.zip}</p>
							</div>
							<div>
								<p className="store-hours bold">Curbside Hours</p>
								<div className={classes.StoreHourItemContainer}>
									{props.openStatus === Constants.STORE_STATUS_CLOSED ?
										<>
											<ClosedMessage type={'curbside'} />
										</>
										:
										<>
											<StoreHourItem day="Monday" hours={curbsideHours.mon} openStatus={props.openStatus} />
											<StoreHourItem day="Tuesday" hours={curbsideHours.tue} openStatus={props.openStatus} />
											<StoreHourItem day="Wednesday" hours={curbsideHours.wed} openStatus={props.openStatus} />
											<StoreHourItem day="Thursday" hours={curbsideHours.thu} openStatus={props.openStatus} />
											<StoreHourItem day="Friday" hours={curbsideHours.fri} openStatus={props.openStatus} />
											<StoreHourItem day="Saturday" hours={curbsideHours.sat} openStatus={props.openStatus} />
											<StoreHourItem day="Sunday" hours={curbsideHours.sun} openStatus={props.openStatus} />
										</>
									}
								</div>
							</div>
							<div>
								<p className="store-hours bold">Store Hours</p>
								<div className={classes.StoreHourItemContainer}>
									{props.openStatus === Constants.STORE_STATUS_CLOSED ?
										<>
											<ClosedMessage type={'in store'} />
										</>
										:
										<>
											<StoreHourItem day="Monday" hours={storeHours.mon} openStatus={props.openStatus} />
											<StoreHourItem day="Tuesday" hours={storeHours.tue} openStatus={props.openStatus} />
											<StoreHourItem day="Wednesday" hours={storeHours.wed} openStatus={props.openStatus} />
											<StoreHourItem day="Thursday" hours={storeHours.thu} openStatus={props.openStatus} />
											<StoreHourItem day="Friday" hours={storeHours.fri} openStatus={props.openStatus}  />
											<StoreHourItem day="Saturday" hours={storeHours.sat} openStatus={props.openStatus} />
											<StoreHourItem day="Sunday" hours={storeHours.sun} openStatus={props.openStatus} />
										</>
									}
								</div>
							</div>
						</Collapse>
					</div>
				</>
				}
			</div>
		);
	}

	return (
		<div className={classes.StoreContainer} data-test-id="store-info-main">
			{!props.inDialog &&
			<div className={classes.Title}>
				<p className="body-small bold upper">Store Information</p>
			</div>
			}
			<div className={classes.StoreTileContainer}>
				<PickupLocation store={props.store}
												showAltChain={showAltChain}
												pickupWebsite={props.pickupWebsite}
												checkedIn={props.checkedIn}
												pickedUp={props.pickedUp}
												inDialog={props.inDialog}
												openStatus={props.openStatus}
												setStoreOpen={props.setStoreOpen}
												setCurbsideStoreOpen={props.setCurbsideStoreOpen}
												setHoursOpen={props.setHoursOpen}
												expired={props.expired}
												extend={props.extend} />
			</div>
		</div>
	);
}
